
const mockLeaderboardTemplates = [
  {
    id: 'template_mock_1',
    createdAt: 1748000000000,
    accountCode: '',
    category: 'L',
    exerciseId: 101,
    exerciseName: 'Back Squat',
    groups: [{ id: 1, name: 'Football' }, { id: 6, name: 'Sophomore Men\'s Field Hockey' }],
    mustBeInAllGroups: false,
    gender: 1,
    rangeType: 1,
    rangeDates: {},
    compareTo: 0,
    compareDates: {},
  },
  {
    id: 'template_mock_2',
    createdAt: 1748100000000,
    accountCode: '',
    category: 'L',
    exerciseId: 102,
    exerciseName: 'Bench Press',
    groups: [{ id: 1, name: 'Football' }, { id: 2, name: 'Basketball' }],
    mustBeInAllGroups: false,
    gender: 0,
    rangeType: 2,
    rangeDates: {},
    compareTo: 1,
    compareDates: {},
  },
  {
    id: 'template_mock_3',
    createdAt: 1748200000000,
    accountCode: '',
    category: 'R',
    exerciseId: 201,
    exerciseName: 'Vertical Jump',
    groups: [{ id: 2, name: 'Basketball' }],
    mustBeInAllGroups: false,
    gender: 0,
    rangeType: 3,
    rangeDates: {},
    compareTo: 0,
    compareDates: {},
  },
  {
    id: 'template_mock_4',
    createdAt: 1748300000000,
    accountCode: '',
    category: 'L',
    exerciseId: 103,
    exerciseName: 'Power Clean',
    groups: [{ id: 3, name: 'Wrestling' }, { id: 4, name: 'Track & Field' }],
    mustBeInAllGroups: true,
    gender: 0,
    rangeType: 1,
    rangeDates: {},
    compareTo: 2,
    compareDates: {},
  },
  {
    id: 'template_mock_5',
    createdAt: 1748400000000,
    accountCode: '',
    category: 'C',
    exerciseId: 301,
    exerciseName: '300 Yard Shuttle',
    groups: [{ id: 1, name: 'Football' }, { id: 3, name: 'Wrestling' }, { id: 5, name: 'Baseball' }],
    mustBeInAllGroups: false,
    gender: 2,
    rangeType: 2,
    rangeDates: {},
    compareTo: 0,
    compareDates: {},
  },
  {
    id: 'template_mock_6',
    createdAt: 1748500000000,
    accountCode: '',
    category: 'R',
    exerciseId: 202,
    exerciseName: 'Broad Jump',
    groups: [{ id: 1, name: 'Football' }],
    mustBeInAllGroups: false,
    gender: 0,
    rangeType: 4,
    rangeDates: {
      startDate: new Date('2024-12-01'),
      endDate: new Date('2025-03-31'),
    },
    compareTo: 4,
    compareDates: {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-03-31'),
    },
  },
];

export default mockLeaderboardTemplates;
